export const zh = {
  title: '预计干旱期变化',
  subtitle: '0.25°, global, 2000-2080, WRI/Vizzuality',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: '功能',
      value: '预计年均干旱期变化',
    },
    {
      label: '分辨率',
      value: '0.25度 × 0.25度',
    },
    {
      label: '地理覆盖范围',
      value: '全球预计干旱期变化',
    },
    {
      label: '来源',
      value: 'WRI/Vizzuality',
    },
    {
      label: '更新频率',
      value: '',
    },
    {
      label: '内容日期',
      value: '',
    },
    {
      label: '注意事项',
      value:
        '-一些全球气候模型（GCM）在再现区域气候模式（如季风）方面表现优于其他模型。在特定应用中，基于区域性能选择个别模型可能更为合适。\n- 用于生成这些指标的降尺度方法固有地假设，在未来气候变化下，温度和降水的相对空间模式将保持不变。然而，全球天气模式可能发生重大变化，例如主要大气和海洋环流的减缓或逆转，但这些变化不会在这些指标中体现。\n- 用于降尺度的历史数据在全球范围内质量不一。特别是在记录时间较短或地面气象观测点较稀疏的地区，数据的准确性可能较低。\n- 由于全球气候模型由独立研究团队开发，并包含不同的假设和机制，因此它们可能涵盖了未来气候的广泛可能性。我们提供高低两种估算值，以便用户查看和评估可能的气候变化范围。',
    },
    {
      label: '许可证',
      value: '[需要署名](https://www.wri.org/publications/permissions-licensing)',
    },
  ],
  overview: {
    label: '概览',
    value:
      '“预计干旱期变化”数据集显示了2000年至2080年间每十年间隔的年均干旱期变化，并与1960-1990年的基准时段进行比较。干旱期定义为连续五天降水量少于1毫米（mm）。每个十年间隔的数据表示的是一个以所示年份为中心的31年平均值。例如，2000年的干旱期数量实际上是1985年至2015年间年均干旱期的平均值。\n\n降水量预测基于政府间气候变化专门委员会（IPCC）提出的代表性浓度路径（RCP）8.5。RCP 8.5 是一种假设情景，即在21世纪内温室气体排放率不会下降。干旱期的变化表示为预测十年的年均干旱期数量与基准时段的相对倍数。数值大于1表示干旱期数量增加，数值小于1表示干旱期数量减少。数据集的空间分辨率为0.25°。\n\n全球温室气体浓度的上升及其引发的气候变化将从根本上改变人类与地球的关系，对农业、基础设施、灾害管理以及社会冲突产生深远影响。为了预测并适应这些变化，**“预计干旱期变化”**数据集提供了未来几十年降水模式可能变化的预测。这一数据集通过汇总全球气候信息，并以常见的地理空间格式作为开放数据提供，从而提高了气候数据的可获取性。\n\n本数据集由 Vizzuality 和 世界资源研究所（WRI） 处理，基于美国国家航空航天局（NASA）的 全球每日降尺度预测数据集（NEX-GDDP）。NEX-GDDP 数据集旨在帮助科学界开展气候变化影响研究，范围涵盖从地方到区域尺度，同时提升公众对未来全球气候模式的理解，使其适用于城镇、城市和流域等空间尺度。\n\n该数据集的早期版本由 气候韧性与准备合作伙伴（PREP） 处理和发布，助力 PREP 的使命，即通过改善气候数据的可获取性来增强对气候变化的适应能力',
  },
  citation: {
    label: '引用',
    value:
      "Gassert, F., E. Cornejo, and E. Nilson. 2021. “Making Climate Data Accessible: Methods for Producing NEX-GDDP and LOCA Downscaled Climate Indicators” Technical Note. Washington, DC: World Resources Institute. Available online at https://www.wri.org/research/making-climate-data-accessible. [www.resourcewatch.org](https://www.resourcewatch.org/). We acknowledge the World Climate Research Programme's Working Group on Coupled Modelling, which is responsible for CMIP, and we thank the climate modeling groups for producing and making available their model output. The U.S. Department of Energy's Program for Climate Model Diagnosis and Intercomparison provides coordinating support and development of software infrastructure in partnership with the Global Organization for Earth System Science Portals for CMIP. Climate scenarios used were from the NEX-GDDP dataset, prepared by the Climate Analytics Group and NASA Ames Research Center using the NASA Earth Exchange, and distributed by the NASA Center for Climate Simulation (NCCS).",
  },
};
